import { render, staticRenderFns } from "./ItemCategories_2.vue?vue&type=template&id=aeacc148&"
import script from "./ItemCategories_2.vue?vue&type=script&lang=js&"
export * from "./ItemCategories_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ItemCategories_2.vue"
export default component.exports